module.exports = {"id":"231942","name":"Han Chan Hee","rating":"72","photo":"./data/images/photos/3/231942.png","club":{"name":"Jeonnam Dragons","logo":"./data/images/clubs/JeonnamDragons.png"},"positions":["MC","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HanChanHee0.json
// module id = 1688
// module chunks = 0